<template>
  <div>
    <a-form-model ref="form" :model="form.data" :rules="form.rules">
      <a-form-model-item
        label="商品">
        <img-goods-select-checkbox v-model="form.data.goodsId"  v-on:confirm="getConfirmTarget" :goodsId="form.data.goodsId"/>
      </a-form-model-item>
      <a-form-model-item>
        <a-space>
          <a-button type="primary" v-if="!topicGoodsId" @click="onAdd">
            {{ $t('CREATE') || '创建' }}
          </a-button>
          <a-button type="primary" v-if="topicGoodsId" @click="onUpdate">
            {{ $t('UPDATE') || '更新' }}
          </a-button>

          <a-button @click="onCancel">{{ $t('CANCEL') || '取消' }}</a-button>
        </a-space>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
import {
  _queryLookBookTopicGoods,
  _addLookBookTopicGoodsList,
  _updateLookBookTopicGoodsList,
} from '@/api/lookBookTopicGoodsApi';
import ImgGoodsSelectCheckbox from '@/components/contentSelector/ImgGoodsSelectCheckbox.vue';

async function getLookBookTopicGoods() {
  const result = await _queryLookBookTopicGoods(this.topicGoodsId);
  if (result) {
    this.form.data.goodsId = result.goodsId;
  }
}

async function onAdd() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _addLookBookTopicGoodsList({
        goodsIds: this.form.data.target,
        topicId: this.topicId,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success(this.$t('ADD_SUCCESS'));
          this.onSubmitHandler();
        }
      }
    }
  });
}

async function onUpdate() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _updateLookBookTopicGoodsList(this.topicGoodsId, {
        goodsIds: this.form.data.target,
        topicId: this.topicId,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success(this.$t('UPDATE_SUCCESS'));
          this.onSubmitHandler();
        }
      }
    }
  });
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

export default {
  name: 'LookBookTopicGoodsEdit',
  components: {
    ImgGoodsSelectCheckbox,
  },
  props: {
    topicGoodsId: String,
    topicId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    topicGoodsId() {
      if (this.topicGoodsId) {
        this.getLookBookTopicGoods();
      }
    },
  },
  methods: {
    onAdd,
    onUpdate,
    onCancel,
    getLookBookTopicGoods,
    getConfirmTarget(data) {
      this.form.data.target = data;
    }
  },
  data() {
    return {
      form: {
        data: {
          goodsId: '',
          target: [],
        },
        rules: {
          goodsId: [{
            required: true,
            trigger: 'blur',
          }],
        },
        title: '',
      },
    };
  },
  created() {
    if (this.topicGoodsId) {
      this.getLookBookTopicGoods();
    }
  },
};
</script>
